var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkCardImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 67,
    viewBox: "0 0 62 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 44.4517C38.4781 44.4517 44.5625 38.466 44.5625 31.1079C44.5625 23.7498 38.4781 17.7642 31 17.7642C23.5219 17.7642 17.4375 23.7498 17.4375 31.1079C17.4375 38.466 23.5219 44.4517 31 44.4517Z",
    fill: "url(#paint0_linear_1599_7678)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35669 49.1104C7.47165 49.1225 7.58532 49.1282 7.69898 49.1282C8.55084 49.1282 9.36588 48.7984 9.97555 48.1986L12.7882 45.432C13.8363 44.4007 14.032 42.8026 13.2641 41.5451C11.3467 38.3986 10.3333 34.7894 10.3333 31.1078C10.3333 27.4262 11.3467 23.817 13.2648 20.6723C14.032 19.4142 13.837 17.8155 12.7888 16.7842L9.97619 14.0176C9.28515 13.3371 8.33448 13.0016 7.35669 13.1052C6.37761 13.2068 5.50896 13.7317 4.97227 14.5463C1.71921 19.4822 0 25.2086 0 31.1078C0 37.007 1.71921 42.7334 4.97163 47.6693C5.50832 48.4833 6.37761 49.0088 7.35669 49.1104Z",
    fill: "url(#paint1_linear_1599_7678)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6434 13.1053C53.6675 13.0004 52.7156 13.3366 52.0239 14.0171L49.2113 16.7844C48.1631 17.8156 47.9674 19.4137 48.7353 20.6712C50.6534 23.8171 51.6667 27.4263 51.6667 31.1079C51.6667 34.7895 50.6534 38.3987 48.7353 41.5434C47.968 42.8015 48.1631 44.4002 49.2113 45.4315L52.0239 48.1981C52.6335 48.7986 53.4486 49.1284 54.3004 49.1284C54.4141 49.1284 54.5284 49.1226 54.6427 49.1106C55.6218 49.0089 56.4905 48.484 57.0271 47.6694C60.2809 42.7335 62.0001 37.0071 62.0001 31.1079C62.0001 25.2087 60.2809 19.4823 57.0284 14.5464C56.4918 13.7324 55.6225 13.207 54.6434 13.1053Z",
    fill: "url(#paint2_linear_1599_7678)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2977 7.84531C49.1944 6.88202 48.6603 6.02738 47.8323 5.49935C42.8161 2.29939 36.9952 0.60791 30.9999 0.60791C25.0047 0.60791 19.1838 2.29939 14.1676 5.49935C13.3403 6.02738 12.8062 6.88202 12.7022 7.84531C12.5995 8.80288 12.9373 9.74203 13.6296 10.4232L16.4422 13.1904C17.4884 14.2204 19.1134 14.4143 20.3921 13.6594C23.5903 11.7722 27.2586 10.7746 30.9999 10.7746C34.7413 10.7746 38.4096 11.7722 41.6078 13.6594C42.1296 13.9669 42.7076 14.1169 43.2818 14.1169C44.1155 14.1169 44.9377 13.8004 45.5577 13.1904L48.3703 10.4232C49.0626 9.74203 49.4004 8.80225 49.2977 7.84531Z",
    fill: "url(#paint3_linear_1599_7678)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6296 51.7927C12.9379 52.4738 12.5995 53.413 12.7022 54.3705C12.8055 55.3338 13.3396 56.1885 14.1675 56.7165C19.1837 59.9165 25.0046 61.6079 30.9999 61.6079C36.9952 61.6079 42.8161 59.9165 47.8323 56.7165C48.6596 56.1885 49.1937 55.3338 49.2977 54.3705C49.4004 53.413 49.0626 52.4738 48.3703 51.7927L45.5577 49.0254C44.5114 47.9954 42.8858 47.8016 41.6077 48.5565C38.4096 50.4437 34.7412 51.4413 30.9999 51.4413C27.2586 51.4413 23.5903 50.4437 20.3921 48.5565C19.1127 47.8022 17.4884 47.9948 16.4422 49.0254L13.6296 51.7927Z",
    fill: "url(#paint4_linear_1599_7678)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1599_7678",
    x1: -5.60596,
    y1: -36.7411,
    x2: 26.2511,
    y2: 109.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1599_7678",
    x1: -11.6647,
    y1: -60.5228,
    x2: 78.1042,
    y2: 93.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1599_7678",
    x1: 36.6042,
    y1: -60.5238,
    x2: 126.374,
    y2: 93.5107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1599_7678",
    x1: -18.4356,
    y1: -26.9828,
    x2: -12.1447,
    y2: 49.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1599_7678",
    x1: -18.4356,
    y1: 20.5079,
    x2: -12.1447,
    y2: 97.3377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkCardImg2);
export default __webpack_public_path__ + "static/media/workCardImg2.7c79fca3359416eeba7dea1213fe8191.svg";
export { ForwardRef as ReactComponent };